import { render, staticRenderFns } from "./toShop.vue?vue&type=template&id=036e7204&"
import script from "./toShop.vue?vue&type=script&lang=js&"
export * from "./toShop.vue?vue&type=script&lang=js&"
import style0 from "./toShop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports